<template>
	<div id="prazo-calendario">
		<div class="prazo-container flex-col">
			<aside class="prazo-sidebar flex justify-between">

				<card-alerts class="mr-5" />
				<card-responsaveis class="mx-5" />
				<card-status class="ml-5" />
			</aside>

			<section class="prazo-main-calendario">
				<simple-calendar ref="simpleCalendar" />
			</section>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import CardAlerts from "./components/card_alerts/CardAlerts.vue";
import CardResponsaveis from "./components/card_responsaveis/CardResponsaveis";
import CardStatus from "./components/card_status/CardStatus";
import SimpleCalendar from "./components/simple_calendar/SimpleCalendar";


import { mapState } from "vuex";

export default {
	name: "Calendario",
	components: {
		CardAlerts,
		CardResponsaveis,
		CardStatus,
		SimpleCalendar,
	},
	computed: {
		hasFiltros() {
			const filtros = this.$store.state.fitrosCalendarioPrazos;
			return (filtros.responsaveis && filtros.responsaveis.length > 0) ||
				(filtros.status && filtros.status.length > 0);
		},
		...mapState(["fitrosCalendarioPrazos"])
	},
	methods: {
		limparFiltros() {
			// Limpa os filtros do store
			this.$store.commit('CLEAR_FILTROS_CALENDARIO_PRAZOS');
			
			// Recarrega os prazos no calendário
			if (this.$refs.simpleCalendar) {
				this.$refs.simpleCalendar.reloadPrazos();
			}
		},
		updateBreadcrumb() {
			this.setBreadcrumb({
				title: "Prazos",
				list: [{ name: "prazos", active: true }],
				action: {
					label: "Limpar Filtros",
					callback: this.limparFiltros,
					disabled: !this.hasFiltros
				}
			});
		},
		...mapActions(["setBreadcrumb"])
	},
	watch: {
		hasFiltros() {
			this.updateBreadcrumb();
		}
	},
	created() {
		this.updateBreadcrumb();
	}
};
</script>

<style lang="scss" scoped src="./calendario.scss"></style>
<style lang="scss" src="./calendario_global.scss"></style>
